/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import { apiUrl } from '../common/constants';
import { RefreshTokenEndpoint } from '../common/endpoints';

class RequestManager {
  private activeRequests: Map<string, Promise<any>> = new Map();
  async request<T>(key: string, requestFn: () => Promise<T>): Promise<T> {
    const existingRequest = this.activeRequests.get(key);
    if (existingRequest) {
      return existingRequest;
    }

    const requestPromise = requestFn()
      .then((result) => {
        this.activeRequests.delete(key);
        return result;
      })
      .catch((error) => {
        this.activeRequests.delete(key);
        throw error;
      });

    this.activeRequests.set(key, requestPromise);

    return requestPromise;
  }

  clear(): void {
    this.activeRequests.clear();
  }

  getKey(endpoint: string, body?: string): string {
    return `${endpoint}${JSON.stringify(body)}`;
  }
}

const requestManager = new RequestManager();


export default requestManager

export const refreshTokenRequest = async (token: string) => {
  const body = { RefreshToken: token };
  const key = requestManager.getKey(RefreshTokenEndpoint, JSON.stringify(body));

  return requestManager.request<{ ok: boolean, status: number, data: unknown }>(key, () => 
    axios.post(`${apiUrl}${RefreshTokenEndpoint}`, body)
      .then(res => ({
        ok: true,
        status: res.status,
        data: res.data
      }))
      .catch(err => ({
        ok: false,
        status: (err as any).response?.status || 500,
        data: null
      }))
  );
};